/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResourceTypeMetricDto } from './ResourceTypeMetricDto';
import {
    ResourceTypeMetricDtoFromJSON,
    ResourceTypeMetricDtoFromJSONTyped,
    ResourceTypeMetricDtoToJSON,
} from './ResourceTypeMetricDto';
import type { ResourceTypeValueDto } from './ResourceTypeValueDto';
import {
    ResourceTypeValueDtoFromJSON,
    ResourceTypeValueDtoFromJSONTyped,
    ResourceTypeValueDtoToJSON,
} from './ResourceTypeValueDto';

/**
 * 
 * @export
 * @interface ResourceTypeDto
 */
export interface ResourceTypeDto {
    /**
     * The name of the resource.
     * @type {string}
     * @memberof ResourceTypeDto
     */
    name: string;
    /**
     * The description of the resource.
     * @type {string}
     * @memberof ResourceTypeDto
     */
    description: string;
    /**
     * The parameters.
     * @type {{ [key: string]: ResourceTypeValueDto; }}
     * @memberof ResourceTypeDto
     */
    parameters: { [key: string]: ResourceTypeValueDto; };
    /**
     * The context.
     * @type {{ [key: string]: ResourceTypeValueDto; }}
     * @memberof ResourceTypeDto
     */
    context: { [key: string]: ResourceTypeValueDto; };
    /**
     * The metrics that the resource can provide.
     * @type {{ [key: string]: ResourceTypeMetricDto; }}
     * @memberof ResourceTypeDto
     */
    metrics: { [key: string]: ResourceTypeMetricDto; };
}

/**
 * Check if a given object implements the ResourceTypeDto interface.
 */
export function instanceOfResourceTypeDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "parameters" in value;
    isInstance = isInstance && "context" in value;
    isInstance = isInstance && "metrics" in value;

    return isInstance;
}

export function ResourceTypeDtoFromJSON(json: any): ResourceTypeDto {
    return ResourceTypeDtoFromJSONTyped(json, false);
}

export function ResourceTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceTypeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'parameters': (mapValues(json['parameters'], ResourceTypeValueDtoFromJSON)),
        'context': (mapValues(json['context'], ResourceTypeValueDtoFromJSON)),
        'metrics': (mapValues(json['metrics'], ResourceTypeMetricDtoFromJSON)),
    };
}

export function ResourceTypeDtoToJSON(value?: ResourceTypeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'parameters': (mapValues(value.parameters, ResourceTypeValueDtoToJSON)),
        'context': (mapValues(value.context, ResourceTypeValueDtoToJSON)),
        'metrics': (mapValues(value.metrics, ResourceTypeMetricDtoToJSON)),
    };
}

